module.exports = __webpack_public_path__ + "img/hand_of_prof_quirrell.8a7106cc.jpg";